import { Field } from "typegraph";


// tslint:disable

class File {
	@Field()
	public url: string;
}

export class Image {
	@Field({entity: File})
	public file: File;
}



// WEBPACK FOOTER //
// ./src/panels/forum/entity/Image.ts